// src/components/data/NoSSR.jsx
import { useState, useEffect } from 'react';

const NoSSR = ({ children, fallback = null }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted ? children : fallback;
};

export default NoSSR;
